export const getGeneratedReportWithIdQueueStorageKey = (
  templatedReportName: string,
  reportId: string
) =>
  `templated-report-${templatedReportName}-template-details-${reportId}-report-export`;
